import { appendToTracking } from 'Tracker'
import WorkflowFallback from '../ActiveVideo/WorkflowFallback'

export default appendToTracking(WorkflowFallback, 'face_motion')
